import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

const useStyles = makeStyles(theme => ({
  colorGridContainer: {
    width: "50%",
    height: 346,
  },
  colorGrid: {
    marginBottom: 20,
    height: "calc(100% - 46px)",
  },
  colorBox: {
    minWidth: "33.3333%",
    textAlign: "center",
  },
  primary: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      color: colors.white,
    },
  },
  secondary: {
    color: theme.palette.secondary.main,
    backgroundColor: theme.palette.secondary.main,
    "&:hover": {
      color: colors.white,
    },
  },
  error: {
    color: theme.palette.error.main,
    backgroundColor: theme.palette.error.main,
    "&:hover": {
      color: colors.white,
    },
  },
  warn: {
    color: theme.palette.warning.main,
    backgroundColor: theme.palette.warning.main,
    "&:hover": {
      color: colors.white,
    },
  },
  black: {
    color: colors.black,
    backgroundColor: colors.black,
    "&:hover": {
      color: colors.white,
    },
  },
  grayDark: {
    color: theme.palette.grey[500],
    backgroundColor: theme.palette.grey[500],
    "&:hover": {
      color: colors.white,
    },
  },
  grayMed: {
    color: theme.palette.grey[300],
    backgroundColor: theme.palette.grey[300],
    "&:hover": {
      color: colors.white,
    },
  },
  grayLight: {
    color: theme.palette.grey[100],
    backgroundColor: theme.palette.grey[100],
    "&:hover": {
      color: colors.black,
    },
  },
  whiteGray: {
    color: theme.palette.grey[50],
    backgroundColor: theme.palette.grey[50],
    "&:hover": {
      color: colors.black,
    },
  },
  offWhite: {
    color: colors.whiteBlue,
    backgroundColor: colors.whiteBlue,
    "&:hover": {
      color: colors.black,
    },
  },
  white: {
    "&:hover": {
      color: colors.black,
    },
    color: colors.white,
    outline: `2px solid ${theme.palette.grey[100]}`,
    outlineOffset: -2,
  },
}));

export default useStyles;
